/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Registrationdatethroughadmin3Inputs */

const en__field_registrationdatethroughadmin3 = /** @type {(inputs: _Field_Registrationdatethroughadmin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registration (through Admin)`)
};

const de__field_registrationdatethroughadmin3 = /** @type {(inputs: _Field_Registrationdatethroughadmin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung (durch Veranstalter)`)
};

/**
* | output |
* | --- |
* | "registration (through Admin)" |
*
* @param {_Field_Registrationdatethroughadmin3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_registrationdatethroughadmin3 = /** @type {((inputs?: _Field_Registrationdatethroughadmin3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Registrationdatethroughadmin3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_registrationdatethroughadmin3(inputs)
	return de__field_registrationdatethroughadmin3(inputs)
});
export { _field_registrationdatethroughadmin3 as "_field_registrationDateThroughAdmin" }